<template>
  <a-modal
    :confirmLoading='confirmLoading'
    :title='title'
    :visible='visible'
    :width='1000'
    @cancel='handleCancel'
    @ok='handleOk'>
    <a-spin :spinning='confirmLoading'>
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm">
        <a-form-model-item  prop="name" label="事件名称">
          <a-input placeholder="请输入事件名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item prop="sortNum" label="序号">
          <a-input-number v-model="model.sortNum" placeholder="请输入序号" :min="0" :precision="0" style="width: 100%"/>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { postAction } from '@/api/manage'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'CsimVisitPeriodModel',
    components: { },
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        title: '表单选择',
        visible: false,
        model: {
          formList:[]
        },
        confirmLoading: false,
        isEdit: false,
      }
    },
    methods: {
      add() {
        //初始化默认值
        this.edit({
          sortNum: 1,
          projectId:this.projectId
        })
      },
      edit(record) {
        this.handleOpen(record,true)
      },
      view(record) {
        this.handleOpen(record,false)
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        if(this.formListVisible){
          this.formListVisible = false
        }
        else{
          this.submit()
        }
      },
      submit(){
        this.$refs.ruleForm.validate(valid  => {
          if(valid){
            this.confirmLoading = true
            postAction('/project/projectVisit/saveOrUpdate',this.model).then(res=>{
              if(res.success){
                this.$message.success(res.message)
                this.close()
              }
            }).finally(()=>{
              this.confirmLoading= false
            })
          }
        })
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>

<style lang='less' scoped>
  .visit_name_row {
    margin-bottom: 8px;
  }
  .main-box {
    padding: 12px;
  }

  /deep/ .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td  .ant-select-selection {
    border: 0!important;
  }
</style>
